import {
    ErrorCode,
    fileToBlob, formatYoutubeLink,
    handleFetchError, IImg,
    showNotice,
    uploadImage,
    YummyServerError
} from "../helpers/functions.js";
import {
    IAnimeVideoPreview,
    IOneAnimeJson,
    IOneAnimeSmallJson,
    VideoBodyJson
} from "../../../../nodeserver/structs/database";
import { ServerApi } from "../api.js";
import {PreviewAnimeItem} from "./edit-preview-item.js";
import {YoutubeApi} from "../iframe-apis/youtube-api";
import JSX from "../helpers/react.js";

$(document)
    .on('paste blur', '.video-blogger-form input[name=link]', async function (){
        await new Promise(r=>setTimeout(r));
        const data = formatYoutubeLink($(this).val()! as string), link = data?.src;
        const $player = $("#player");
        if(link) {
            $(this).val(link);
            if($player.prop('src') !== link)
                $player.prop('src', link);
        }
        else {
            if(!$player.prop('src').startsWith('data:text/html'))
                $player.prop('src', noPreviewHtmlSrc);
        }
        if(data?.imgs) updateImgs(data.imgs);
    })
    .on('click', '.video-blogger-form #upload-preview-img', async function(e){
        e.preventDefault();
        if($(this).hasClass('blocked'))return;
        $('#choice-img').trigger('click');
    })
    .on( 'input','.video-blogger-form #choice-img', async function(ev){
        //@ts-ignore
        const buffer: File = ev.originalEvent!.target!.files![0]!;//.arrayBuffer() as ArrayBuffer;
        if(!buffer) return;
        try {
            $('#upload-preview-img').addClass('blocked').html('<i class="loading"></i> Загрузка')
            const file = await fileToBlob(buffer);
            const url = await uploadImage(file);
            $('#preview-big,#preview-small').val(url);
            $('#preview-img').prop('src', url);
        }catch (e){
            handleFetchError(e);
        }
        finally {
            $('#upload-preview-img')
                .removeClass('blocked').text('Загрузить')
        }
    })
    .on('input', '.video-blogger-form #preview-big', function(e){
        $('#preview-img').prop('src', $(this).val())
    })
    .on('input', '.video-blogger-form #add-anime-related', async function (){
        const val = $(this).val()! as string;
        if( /yummyani\.me|yani\.tv|yummy-anime\.ru/.test(val)) {
            try {
                const anime = await getAnimeFromUrl(val);
                if(anime) {
                    addNewAnime(anime);
                    $(this).val('')
                }
                else showNotice('Аниме по ссылке не найдено. Можно вводить ТОЛЬКО ссылку на YummyAnime!', 'Ошибка', 'error');
            }catch (e){
                handleFetchError(e);
                return;
            }
        }
        else if(val.length>=3) await searchAnimeFromWord(val);
    })
    .on('blur', '.video-blogger-form #add-anime-related',()=>{$('#search-container').fadeOut()})
    .on('focus', '.video-blogger-form #add-anime-related',()=>{$('#search-container').fadeIn()})
    .on('click', '.video-blogger-form .anime-search', function(){
        addNewAnime($(this).data('anime') as IOneAnimeJson);
        $('#add-anime-related').val('')
    })
    .on('submit', '.video-blogger-form', async function (e){
        e.preventDefault();
        const $this = $(this);
        if($this.hasClass('blocked')) return;
        try {
            $this.addClass('blocked')
            const formData = buildData();
            if($this.is('#add-video')) {
                const videoId = await ServerApi.bloggers.video.add(formData)
                window.location.href = `/blogger/video/${videoId}`
            }
            else{
                const videoId = await ServerApi.bloggers.video.edit(page_id!, formData);
                window.location.href = `/blogger/video/${page_id}`
            }
        }
        catch (e){
            handleFetchError(e);
        }
        finally {
            $(this).removeClass('blocked');
        }
    })

$(()=> $('.video-blogger-form input[name=link]').trigger('paste'));

export const noPreviewHtmlSrc = "data:text/html,<html style='background:black' lang='ru'><meta charset='UTF-8'><i style='top: 50%; left:50%;transform:translate(-50%,-50%);position:absolute;color:white;text-align:center;font-size:17px;'>Введите ссылку на видео, чтобы превью отобразилось тут</div></html>";


async function getAnimeFromUrl(url: string){
    let id: string|undefined|null;
    if(url.includes('/catalog/item/')){
        id = url.split('/catalog/item/')[1]?.split('?')[0];
    }
    if(!id) id = url.match(/\/a(\d+)/)?.[1];
    if(id) return ServerApi.anime.get(id).catch(e=>{
        if(e instanceof YummyServerError && e.code === ErrorCode.NotFountError) return null;
        throw e;
    });
    return null;
}
async function searchAnimeFromWord(query: string){
    const animes = await ServerApi.anime.search(query);
    const $container = $("#search-container").text('')[0];
    for(const anime of animes){
        $container.appendChild(
            <AnimeSearchResult anime={anime}/>
        );
        // $().appendTo($container);
    }
}
function AnimeSearchResult({anime}: {anime: IOneAnimeSmallJson}){
    return (<div className="anime-search" data-anime={JSON.stringify(anime)}>
        <div className="title">{anime.title}</div>
        <div className="live-search-year" style="float: right">{anime.year}</div>
    </div>)
}


function updateImgs(imgs: IImg){
    $('#preview-big').val(imgs.big);
    $('#preview-small').val(imgs.small);
    $('#preview-img').prop('src', imgs.big);
}
function addNewAnime(anime: IAnimeVideoPreview){
    if(PreviewAnimeItem.elements.some(e=>e.data.anime_id === anime.anime_id))
        return showNotice("Такое аниме уже есть в списке. Добавлять каждое аниме можно только по 1 разу!", 'Ошибка повтора', 'error');
    PreviewAnimeItem.create(anime, $('.anime-selector .data .container'));
    $('.anime-selector h3 b').text(PreviewAnimeItem.elements.length)
}

function buildData(): VideoBodyJson{
    const $parent = $('.video-blogger-form');

    return {
        category: $parent.find('#category').val() as "top" | "review" | "amv" | "news" | "other",
        title: $parent.find('input[name=title]').val()! as string,
        descriptions:{
            small: $parent.find('#description-small').val()! as string,
            full: $parent.find('#description-big').val()! as string
        },
        anime_ids: PreviewAnimeItem.elements.map(el=>({id: el.data.anime_id, timing: el.timing})),
        iframe: $parent.find('input[name=link]').val()! as string,
        previews: {
            big: $parent.find('#preview-big').val()! as string,
            small: $parent.find('#preview-small').val()! as string
        },
        has_spoiler: $parent.find('.add-video-switch .switch').hasClass('active')
    };
}
$( function(){
    const animes: IAnimeVideoPreview[] = $('.video-blogger-form .anime-selector .data').data('animes') || [];
    animes.forEach(addNewAnime);
})